import React from 'react';
import { Routes, Route, Navigate } from "react-router-dom";

import Home from "./Content/Home/Home";
import Photos from "./Content/Photos/Photos";
import Team from "./Content/Team/Team";
import Products from "./Content/Products/Products";
import Contact from "./Content/Contact/Contact";

export default function Router() {
    return (
        <Routes>
            <Route exact path={"/"} element={<Home />} />

            <Route exact path="/team" element={<Team />} />
			<Route exact path="/photos" element={<Photos />} />
            <Route exact path="/products" element={<Products />} />
            <Route exact path="/contact" element={<Contact />} />

            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};
